import React from "react";
import { Outlet, useLocation } from "react-router-dom";

const AuthFeature = () => {
  const location = useLocation();
  const layoutPages = location.pathname === "/coming-soon" ||location.pathname === "/under-maintenance" ||location.pathname === "/under-construction";
  const isLoginPage = location.pathname === "/login"
    || location.pathname === "/forgot-password";
  const isLandingPage = location.pathname === "/";

  if (isLandingPage) {
    return <Outlet />;
  }

  return (
    <div className={`${isLoginPage ? "auth-login-layout" : "bg-linear-gradiant"} ${layoutPages ? "d-flex align-items-center justify-content-center" : ""}`}>
      <div className={`main-wrapper${isLoginPage ? " auth-login-layout__wrapper" : ""}`}>
        <Outlet />
      </div>
    </div>
  );
};

export default AuthFeature;
